import $ from 'jquery';
window.jQuery = $;

import consentReview from './consent-review';

export default {
  init() {
    // Configuration object for all your placeholders
    const placeholders = {
      '$$SERVICE': '.consent-field--service',
      '$$NAME': '.consent-field--nameLegal .name_first',
    };

    // Function to get the name value with fallback logic
    function getNameValue() {
      // First check chosen name
      const chosenName = $('.consent-field--nameChosen input[type="text"]').val();
      if (chosenName && chosenName.trim() !== '') {
        return chosenName.trim();
      }

      // Fall back to legal first name
      const legalFirstName = $('.consent-field--nameLegal .name_first input').val();
      if (legalFirstName && legalFirstName.trim() !== '') {
        return legalFirstName.trim();
      }

      return '';
    }

    // Function to get the artist value based on service type
    function getArtistValue() {
      // Get the selected service
      const service = $('.consent-field--service input[type="radio"]:checked').val();

      if (service === 'Piercing') {
        // Get piercer from select field
        const piercer = $('.consent-field--piercer select').val();
        return piercer || '';
      } else if (service === 'Tattoo') {
        // Get tattoo artist from select field
        const tattooArtist = $('.consent-field--tattooArtist select').val();
        return tattooArtist || '';
      }

      return '';
    }

    // Function to update all placeholders
    function updatePlaceholders() {
      // Get all the current values first
      const values = {};
      $.each(placeholders, function(placeholder, wrapperClass) {
        const $radio = $(wrapperClass + ' input[type="radio"]:checked');
        const radioValue = $radio.val();
        const $input = $(wrapperClass + ' input[type="text"]');
        const inputValue = $input.val();

        values[placeholder] = radioValue || inputValue || '';
      });

      // Handle special $$NAME placeholder with fallback logic
      values['$$NAME'] = getNameValue();

      // Handle special $$ARTIST placeholder with conditional logic
      values['$$ARTIST'] = getArtistValue();

      // Find ALL text nodes in the form that might contain placeholders
      // Not just gfield_description, but everything in the form
      $('form .gform_body *').contents().each(function() {
        // Only process text nodes
        if (this.nodeType === 3) {
          let text = this.nodeValue;
          let originalText = $(this).data('original-text');

          // Store original if not stored
          if (!originalText) {
            $(this).data('original-text', text);
            originalText = text;
          }

          // Start with original text
          let updatedText = originalText;

          // Replace all placeholders
          $.each(values, function(placeholder, value) {
            if (value) {
              const regex = new RegExp(placeholder.replace(/\$/g, '\\$'), 'g');
              updatedText = updatedText.replace(regex, value);
            }
          });

          // Update the text node if it changed
          if (updatedText !== text) {
            this.nodeValue = updatedText;
          }
        }
      });

      // Also handle HTML elements (for backward compatibility)
      $('.gfield_description, .gfield_label, .gfield_html, .gform_page_footer').each(function() {
        const $element = $(this);

        if (!$element.data('original-html')) {
          $element.data('original-html', $element.html());
        }

        let updatedHtml = $element.data('original-html');

        $.each(values, function(placeholder, value) {
          if (value) {
            const regex = new RegExp(placeholder.replace(/\$/g, '\\$'), 'g');
            updatedHtml = updatedHtml.replace(regex, '<strong>' + value + '</strong>');
          }
        });

        $element.html(updatedHtml);
      });
    }

    // Run on page load with a slight delay
    setTimeout(function() {
      updatePlaceholders();
    }, 500);

    // Listen for changes on all form inputs
    $.each(placeholders, function(placeholder, wrapperClass) {
      $(document).on('change', wrapperClass + ' input', function() {
        updatePlaceholders();
      });
      $(document).on('input', wrapperClass + ' input[type="text"]', function() {
        updatePlaceholders();
      });
    });

    // Listen for Gravity Forms page navigation
    $(document).on('gform_page_loaded', function(event, form_id, current_page) {
      setTimeout(function() {
        updatePlaceholders();
      }, 100);
    });



    /**
     * Age-based guardian field requirement handler for Gravity Forms
     */

        // Storage key for guardian requirement status
    const GUARDIAN_REQUIRED_KEY = 'gf_guardian_required';

    /**
     * Calculate age from birthdate
     */
    const calculateAge = (birthdate) => {
      const today = new Date();
      const birth = new Date(birthdate);
      let age = today.getFullYear() - birth.getFullYear();
      const monthDiff = today.getMonth() - birth.getMonth();

      // Adjust if birthday hasn't occurred this year
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
      }

      return age;
    };

    /**
     * Check if guardian is required based on age
     */
    const isGuardianRequired = (birthdate) => {
      if (!birthdate) return false;
      const age = calculateAge(birthdate);
      return age < 18;
    };

    /**
     * Clear guardian token from storage
     */
    const clearGuardianToken = () => {
      sessionStorage.removeItem(GUARDIAN_REQUIRED_KEY);
    };

    /**
     * Update guardian requirement status
     */
    const updateGuardianRequirement = (isRequired) => {
      // Store in sessionStorage for multi-page form persistence
      sessionStorage.setItem(GUARDIAN_REQUIRED_KEY, isRequired ? '1' : '0');

      const $guardianNameField = $('.consent-field--guardianName');
      const $guardianRelationshipField = $('.consent-field--guardianRelationship');
      const $idMinorField = $('.consent-field--idMinor');
      const $idGuardianshipField = $('.consent-field--idGuardianship');

      if (isRequired) {
        // Show fields
        $guardianNameField.show();
        $guardianRelationshipField.show();
        $idMinorField.show();
        $idGuardianshipField.show();

        // Add required indicator
        $guardianNameField.addClass('gfield_contains_required');
        $guardianRelationshipField.addClass('gfield_contains_required');
        $idMinorField.addClass('gfield_contains_required');
        $idGuardianshipField.addClass('gfield_contains_required');

        // Enable validation
        $guardianNameField.find('input, select, textarea').attr('aria-required', 'true');
        $guardianRelationshipField.find('input, select, textarea').attr('aria-required', 'true');
        $idMinorField.find('input[type="file"]').attr('aria-required', 'true');
        $idGuardianshipField.find('input[type="file"]').attr('aria-required', 'true');
      } else {
        // Hide fields
        $guardianNameField.hide();
        $guardianRelationshipField.hide();
        $idMinorField.hide();
        $idGuardianshipField.hide();

        // Remove required indicator
        $guardianNameField.removeClass('gfield_contains_required');
        $guardianRelationshipField.removeClass('gfield_contains_required');
        $idMinorField.removeClass('gfield_contains_required');
        $idGuardianshipField.removeClass('gfield_contains_required');

        // Disable validation
        $guardianNameField.find('input, select, textarea').attr('aria-required', 'false');
        $guardianRelationshipField.find('input, select, textarea').attr('aria-required', 'false');
        $idMinorField.find('input[type="file"]').attr('aria-required', 'false');
        $idGuardianshipField.find('input[type="file"]').attr('aria-required', 'false');

        // Clear field values when hiding
        $guardianNameField.find('input, select, textarea').val('');
        $guardianRelationshipField.find('input, select, textarea').val('');

        // Clear file upload fields (Gravity Forms specific)
        $idMinorField.find('input[type="file"]').val('');
        $idGuardianshipField.find('input[type="file"]').val('');

        // Remove any uploaded file indicators
        $idMinorField.find('.gform_delete').trigger('click');
        $idGuardianshipField.find('.gform_delete').trigger('click');
      }
    };

    /**
     * Get stored guardian requirement status
     */
    const getStoredGuardianStatus = () => {
      return sessionStorage.getItem(GUARDIAN_REQUIRED_KEY) === '1';
    };

    /**
     * Initialize birthdate field monitoring
     */
    const initBirthdateMonitoring = () => {
      const $birthdateWrapper = $('.consent-field--birthdate');

      if ($birthdateWrapper.length === 0) return;

      // Find the date input (Gravity Forms uses various formats)
      const $dateInput = $birthdateWrapper.find('input[type="text"], input[type="date"]');

      if ($dateInput.length === 0) return;

      // Disable keyboard on tablets while keeping datepicker functional
      $dateInput.attr('readonly', 'readonly');
      $dateInput.attr('inputmode', 'none'); // Prevents keyboard on modern browsers

      // Set max date to today (no future dates)
      const today = new Date().toISOString().split('T')[0];
      $dateInput.attr('max', today);

      // Check on page load if there's already a value
      if ($dateInput.val()) {
        const isRequired = isGuardianRequired($dateInput.val());
        updateGuardianRequirement(isRequired);
      } else {
        // Check if we have a stored status from previous page
        const storedStatus = getStoredGuardianStatus();
        if (storedStatus) {
          updateGuardianRequirement(true);
        }
      }

      // Monitor for changes
      $dateInput.on('change blur', function() {
        const birthdate = $(this).val();
        const isRequired = isGuardianRequired(birthdate);
        updateGuardianRequirement(isRequired);
      });

      // Also monitor datepicker selection if using Gravity Forms datepicker
      $dateInput.on('input', function() {
        const birthdate = $(this).val();
        if (birthdate && birthdate.length >= 8) { // Basic validation
          const isRequired = isGuardianRequired(birthdate);
          updateGuardianRequirement(isRequired);
        }
      });
    };

    /**
     * Initialize on other pages of multi-page form
     */
    const initOtherPages = () => {
      // If guardian fields aren't on this page, check if they should be required elsewhere
      const $birthdateWrapper = $('.consent-field--birthdate');
      const $guardianFields = $('.consent-field--guardianName, .consent-field--guardianRelationship, .consent-field--idMinor, .consent-field--idGuardianship');

      // If we're on a page without birthdate but with guardian fields
      if ($birthdateWrapper.length === 0 && $guardianFields.length > 0) {
        const storedStatus = getStoredGuardianStatus();
        updateGuardianRequirement(storedStatus);
      }
    };

    /**
     * Clear token on form submission (successful completion)
     */
    const initFormSubmitCleanup = () => {
      // Listen for Gravity Forms confirmation page load (successful submission)
      $(document).on('gform_confirmation_loaded', function(event, formId) {
        clearGuardianToken();
      });

      // Also clear when user reaches a confirmation page (alternative detection)
      if ($('.gform_confirmation_message').length > 0) {
        clearGuardianToken();
      }
    };

    // Initialize on document ready
    $(document).ready(() => {
      initBirthdateMonitoring();
      initOtherPages();
      initFormSubmitCleanup();
      initPageTracking();
    });

    // Re-initialize after Gravity Forms AJAX page change
    $(document).on('gform_page_loaded', () => {
      initBirthdateMonitoring();
      initOtherPages();
      initPageTracking();
    });

    // Export for use in other parts of your application
    window.GFGuardianHelper = {
      isRequired: getStoredGuardianStatus,
      calculateAge: calculateAge,
      clearToken: clearGuardianToken,
    };

    // Form Review Areas
    consentReview.init();



    /**
     * Track highest page reached and update step classes
     */
    const initPageTracking = () => {
      const STORAGE_KEY = 'gf_highest_page_2'; // Change 2 to your form ID

      // Clear storage if no partial entry hash in URL
      const clearIfNoPartialEntry = () => {
        // Check if URL has the partial entry hash (#gf_2)
        if (!window.location.hash.includes('#gf_')) {
          sessionStorage.removeItem(STORAGE_KEY);
          console.log('No partial entry hash found - cleared page tracking');
        }
      };

      // Get current page from active step
      const getCurrentPage = () => {
        const $activePage = $('.gf_step_active');
        if ($activePage.length === 0) return 1;
        return $activePage.index('.gf_step') + 1;
      };

      // Get highest page reached from storage
      const getHighestPage = () => {
        return parseInt(sessionStorage.getItem(STORAGE_KEY) || '1');
      };

      // Update highest page if current is higher
      const updateHighestPage = () => {
        const currentPage = getCurrentPage();
        const highestPage = getHighestPage();

        if (currentPage > highestPage) {
          sessionStorage.setItem(STORAGE_KEY, currentPage.toString());
        }

        console.log('Current page:', currentPage, 'Highest reached:', Math.max(currentPage, highestPage));
      };

      // Update step classes based on highest page reached
      const updateStepClasses = () => {
        const currentPage = getCurrentPage();
        const highestPage = getHighestPage();

        $('.gf_step').each(function(index) {
          const $step = $(this);
          const stepNumber = index + 1;

          // Remove old handler
          $step.off('click');
          $step.css('cursor', 'default');

          // If this step has been reached before and isn't the current page
          if (stepNumber <= highestPage && stepNumber !== currentPage) {
            // Mark as completed
            $step.removeClass('gf_step_pending');
            if (!$step.hasClass('gf_step_completed')) {
              $step.addClass('gf_step_completed');
            }

            // Make clickable
            $step.css('cursor', 'pointer');
            $step.on('click', function(e) {
              e.preventDefault();
              navigateToPage(stepNumber);
            });

            // Hover effect
            $step.on('mouseenter', function() {
              $(this).css('opacity', '0.7');
            }).on('mouseleave', function() {
              $(this).css('opacity', '1');
            });
          }
        });
      };

      // Navigate to a specific page
      const navigateToPage = (targetPage) => {
        const currentPage = getCurrentPage();
        console.log('Navigating from page', currentPage, 'to page', targetPage);

        const $form = $('.gf_page_steps').closest('form');
        const formId = $form.find('input[name="gform_submit"]').val();

        // Set source and target page
        let $sourcePageInput = $form.find('input[name="gform_source_page_number_' + formId + '"]');
        if ($sourcePageInput.length === 0) {
          $sourcePageInput = $('<input>')
              .attr('type', 'hidden')
              .attr('name', 'gform_source_page_number_' + formId)
              .appendTo($form);
        }
        $sourcePageInput.val(currentPage);

        let $targetPageInput = $form.find('input[name="gform_target_page_number_' + formId + '"]');
        if ($targetPageInput.length === 0) {
          $targetPageInput = $('<input>')
              .attr('type', 'hidden')
              .attr('name', 'gform_target_page_number_' + formId)
              .appendTo($form);
        }
        $targetPageInput.val(targetPage);

        $form.submit();
      };

      // Clear storage on form submission
      $(document).on('gform_confirmation_loaded', function(event, formId) {
        if (formId == 2) { // Change to your form ID
          sessionStorage.removeItem(STORAGE_KEY);
          console.log('Cleared highest page tracking on form submission');
        }
      });

      // Also clear when confirmation page is visible (backup method)
      if ($('.gform_confirmation_message').length > 0) {
        sessionStorage.removeItem(STORAGE_KEY);
        console.log('Cleared highest page tracking on confirmation page');
      }

      // Check and clear if no partial entry hash
      clearIfNoPartialEntry();

      // Initialize
      updateHighestPage();
      updateStepClasses();
    };




  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};